import React, { useEffect, useState } from "react"
import MyReviewsHeader from "../components/my-reviews-header"
import store from "src/store"
import ReviewCard from "src/components/review-card"
import Progress from "../components/progress"
import MyReviewsFilters from "src/components/my-reviews-filters"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import Disclaimer from "src/components/disclaimer"

export default function MyReviews() {
  const { isLoggedIn, userInfo } = useIsLoggedIn()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getReviewList()
    store.fetchUserEngagements()
  }, [])

  const getReviewList = async () => {
    setLoading(true)
    await store.fetchtMyReviews()
    setLoading(false)
  }

  store.useRerenderIfChange(() => [store.myReviews])

  const getReviewError = () => {
    if (store.myReviews === undefined || !Array.isArray(store.myReviews)) {
      return "Unable to fetch reviews"
    } else {
      return "No review found"
    }
  }

  return (
    <>
      {" "}
      {isLoggedIn ? (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <div>
            <MyReviewsHeader />
            <Disclaimer />
          </div>
          <hr
            css={`
              margin-top: 15px;
              border: 1px solid #eaeaf2;
            `}
          />
          {!userInfo?.auth0Subscripton &&
          !loading &&
          store.allMyReviews.length ? (
            <div
              css={`
                margin-top: 25px;
                margin-bottom: 25px;
              `}
            >
              <MyReviewsFilters setLoading={setLoading} />
            </div>
          ) : null}

          <div
            css={`
              margin-top: 25px;
              margin-bottom: 100px;
              clear: both;
              overflow: auto; /* Enable both vertical and horizontal scrolling */
            `}
          >
            {loading && <Progress />}
            {!loading && (
              <div
                css={`
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 20px;
                `}
              >
                {store.myReviews?.length
                  ? store.myReviews?.map((item, index) => (
                      <ReviewCard key={index} review={item} />
                    ))
                  : getReviewError()}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <h2 css="color: red;">Access denied!</h2>
        </div>
      )}
    </>
  )
}
